import styled from "styled-components";
import { mainFont, black, gray } from "../../utils/StyleHelpers";
import btnImage from "../../assets/images/Union.svg";

export const StyledVideoTitle = styled.div`
  overflow: hidden;
  color: ${black};
  font-family: ${mainFont};
  text-overflow: ellipsis;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const StyledContent = styled.div`
  align-self: stretch;
  color: ${gray};
  font-family: ${mainFont};
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const StyledTags = styled.a`
  height: 1.1875rem;
  align-self: stretch;
  overflow: hidden;
  color: ${black};
  white-space: nowrap;
  font-family: ${mainFont};
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;
  text-overflow: ellipsis;
`;

export const StyledSubContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 0.75rem;
  align-self: stretch;
`;

export const StyledVideoLength = styled.div`
  align-self: stretch;
  overflow: hidden;
  color: ${black};
  text-overflow: ellipsis;
  font-family: ${mainFont};
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const StyledVideoLengthContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.125rem;
  flex: 1 0 0;
`;

export const StyledButtonDropdown = styled.div`
  display: flex;
  width: 1.5rem;
  height: 1.5rem;
  padding: 0.3125rem 0.625rem;
  justify-content: center;
  align-items: center;
  gap: 0.625rem;
  border-radius: 6.25rem;
  background: url(${btnImage}) 100% / cover no-repeat;
  background-size: auto;
`;
